module.exports = __webpack_public_path__ + "img/1270885001.be0cfef6.jpg";